import { ClassNameMap } from '@mui/material/styles'
import { ResponsiveBar } from '@nivo/bar'

interface BarChartComponentProps {
  classes: ClassNameMap<string>
  data: any[]
  keys: string[]
  theme: any
  indexBy: string
  colors: string[]
  gridYValues: number
  axisBottomLegend: string
  showToolTip: boolean
  leftTickValues?: number
}

export const BarChartComponent: React.FC<BarChartComponentProps> = ({
  classes,
  data,
  keys,
  indexBy,
  theme,
  colors,
  gridYValues,
  axisBottomLegend,
  showToolTip,
  leftTickValues,
}) => {
  return (
    <div
      className={classes.responsiveLineWrapper}
      data-testid="bar-chart-component"
    >
      <ResponsiveBar
        data={data}
        keys={keys}
        indexBy={indexBy}
        margin={{ top: 10, right: 0, bottom: 45, left: 24 }}
        padding={0.55}
        innerPadding={1}
        theme={theme}
        groupMode="grouped"
        gridYValues={gridYValues}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={colors}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 0,
          tickPadding: 3.37,
          tickRotation: 0,
          legend: axisBottomLegend,
          legendPosition: 'middle',
          legendOffset: 38,
        }}
        axisLeft={{
          tickSize: 0,
          tickPadding: 6,
          tickRotation: 0,
          legendOffset: -32,
          tickValues: leftTickValues || 1,
        }}
        enableLabel={false}
        isInteractive={showToolTip}
        tooltip={point => {
          return <div className={classes.tooltip}>{point.value}</div>
        }}
      />
    </div>
  )
}
